<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="800"
      persistent
      scrollable
    >
      <v-card
        class="d-flex flex-column"
        max-height="80vh"
      >
        <v-app-bar
          color="cyan"
          dark
          flat
        >
          <v-toolbar-title class="text-h5">
            Kiosk Actions
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="_ => onCancelKioskActions()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-app-bar>

        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="_ => onCancelKioskActions()"
          >
            cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="primary"
            @click="confirmationDialog = !confirmationDialog"
          >
            {{ currentAction }} on Kiosk
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmationDialog
      cancel-button-color="secondary darken-1"
      confirm-button-color="primary darken-1"
      :title="confirmationDialogTitle"
      :visible="confirmationDialog"
      @canceled="_ => onCancelKioskActions()"
      @confirmed="_ => onConfirmKioskActions()"
    />
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { INTEGRATION_NAMESPACE } from '@/store/integrations'
import { PARTY_NAMESPACE } from '@/store/party'

import ConfirmationDialog from '@/components/Dialogs/Common/ConfirmationDialog.vue'

export default {
  name: 'KioskActionsDialog',

  components: {
    ConfirmationDialog,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      confirmationDialog: false,
    }
  },

  computed: {
    confirmationDialogTitle () {
      return `Are you sure you want to ${this.currentAction} this party on Kiosk?`
    },

    currentAction () {
      return this.peParty.kiosk_status === 'active' ? 'deactivate' : 'activate'
    },

    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  methods: {
    onCancelKioskActions () {
      this.confirmationDialog = false
      this.dialog = false
    },

    onConfirmKioskActions () {
      this[`${this.currentAction}OnKiosk`](this.peParty.id).
        then(_ => this.displayAlert('success', `Party has been ${this.currentAction}ed on Kiosk.`)).
        catch(({ data }) => this.displayAlert('error', data.message || 'Internal Server Error')).
        finally(_ => this.onCancelKioskActions())
    },

    ...mapActions(INTEGRATION_NAMESPACE, [
      'activateOnKiosk',
      'deactivateOnKiosk',
    ]),
  },
}
</script>
